'use strict';

"use strict";
const pluginVersion = "12.4.1";
const defaultOptions = {
  layers: []
};
const defaultMapViewConfig = {
  allLayers: true,
  id: "zero",
  lat: 0,
  lon: 0,
  noRepeat: false,
  zoom: 1
};
var TooltipMode = /* @__PURE__ */ ((TooltipMode2) => {
  TooltipMode2["Details"] = "details";
  TooltipMode2["None"] = "none";
  return TooltipMode2;
})(TooltipMode || {});
var MapCenterID = /* @__PURE__ */ ((MapCenterID2) => {
  MapCenterID2["Coords"] = "coords";
  MapCenterID2["Fit"] = "fit";
  MapCenterID2["Zero"] = "zero";
  return MapCenterID2;
})(MapCenterID || {});

exports.MapCenterID = MapCenterID;
exports.TooltipMode = TooltipMode;
exports.defaultMapViewConfig = defaultMapViewConfig;
exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
